export default __webpack_public_path__ + "static/media/folder-horizontal-open.838cb1ee.png";